import { render, staticRenderFns } from "./ObjectAcceptCell.vue?vue&type=template&id=049e49d6&scoped=true"
import script from "./ObjectAcceptCell.vue?vue&type=script&lang=js"
export * from "./ObjectAcceptCell.vue?vue&type=script&lang=js"
import style0 from "./ObjectAcceptCell.vue?vue&type=style&index=0&id=049e49d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049e49d6",
  null
  
)

export default component.exports